import type { LoadDescriptor } from "building-types/electrical/electricalTypes";
import type { ElectricalItemCatalogSettings } from "building-types/settings/electricalItemCatalogSettings";
import type { Table } from "common/data/table";
import { defaultLoadCatalog } from "./elements/electrical/electricalTools";
import { isVirtualLoad } from "./settingsTools";

export function getLoadCatalog(electricalItemCatalogSettings: ElectricalItemCatalogSettings): Table<LoadDescriptor> {
  const loadCatalog = electricalItemCatalogSettings?.loadTypes;

  return { ...loadCatalog, ...defaultLoadCatalog };
}

export const getLoadCatalogIdsForUi = (loadCatalog: Table<LoadDescriptor>) => {
  return Object.values(loadCatalog)
    .filter((loadDescriptor) => {
      return !isVirtualLoad[loadDescriptor.id];
    })
    .map((desc) => desc.id)
    .sort();
};
